import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { VariableNode } from "./VariableNode";
import { $insertNodes } from "lexical";
import React, { useState } from "react";

type InsertVariablePluginProps = {
  variables: string[];
};

// FUTURE: substituir <select> por:
// - painel com busca / categorias / drag & drop
// - exibir descrição, tipo e exemplo
// - filtro de obrigatórias vs opcionais
export function InsertVariablePlugin({ variables }: InsertVariablePluginProps) {
  const [editor] = useLexicalComposerContext();
  const [selected, setSelected] = useState("");

  const handleInsert = () => {
    if (selected) {
      editor.update(() => {
        $insertNodes([new VariableNode(selected)]);
      });
      setSelected("");
    }
  };

  return (
    <div className="mb-2 flex gap-2 items-center">
      <select
        value={selected}
        onChange={e => setSelected(e.target.value)}
        className="border rounded px-2 py-1 text-sm"
      >
        <option value="">Selecione uma variável</option>
        {variables.map(v => (
          <option key={v} value={v}>{v}</option>
        ))}
      </select>
      <button
        type="button"
        onClick={handleInsert}
        className="px-2 py-1 text-sm border rounded"
        disabled={!selected}
      >
        Inserir variável
      </button>
    </div>
  );
}